module.exports = __webpack_public_path__ + "images/emoji/wedding.8d05387bdef09f761fd1.png";